export const FETCH_APPLICATIONS = 'applications/FETCH_APPLICATIONS';
